export const globalSelf = typeof self === "undefined" ? undefined : self;
//# sourceMappingURL=global-self.js.map